"use client";
import AuthPage from "@/components/common/AuthPage/AuthPage";
import { useRouter, useSearchParams } from "next/navigation";

export default function Login() {
  const router = useRouter();
  const searchParams = useSearchParams();

  const invitationEmail = searchParams.get("email");
  const invitationToken = searchParams.get("redirect")?.replace("/invite/", "");
  const slug = searchParams.get("slug");

  const handleEmailLogin = () => {
    let url = "/verify-email";
    const params = new URLSearchParams();

    if (invitationEmail) params.append("email", invitationEmail);
    if (invitationToken) params.append("invitation", invitationToken);
    if (slug) params.append("slug", slug);

    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    router.push(url);
  };

  return (
    <AuthPage
      mode="login"
      onEmailAuth={handleEmailLogin}
      redirectPath="/dashboard"
    />
  );
}
